import { Refresh } from "@mui/icons-material";
import {
	Box,
	Toolbar,
	Typography,
	Grid,
	Button,
	CircularProgress,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import { useState, useEffect } from "react";
import AppSidebar from "../../components/AppSidebar/AppSidebar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Controls from "../../components/controls/Controls";
import tMobileService from "../../services/tMobileService";

export default function TMobile() {
	const [deviceData, setDeviceData] = useState<any>([]);
	const [loading, setLoading] = useState(false);
	const [limit, setLimit] = useState(50);
	const Limits = [
		{ id: 50, title: "50" },
		{ id: 100, title: "100" },
		{ id: 150, title: "150" },
		{ id: 200, title: "200" },
	];

	async function FetchDeviceData() {
		try {
			setLoading(true);
			const resp = await tMobileService.getAllDevices(limit);
			setDeviceData(resp?.data);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		FetchDeviceData();
	}, [limit]);

	const handleRefreshData = () => {
		FetchDeviceData();
	};
	const handleLimitChange = (event: any) => {
		setLimit(event.target.value);
	};
	return (
		<Box sx={{ display: "flex" }}>
			<AppSidebar />
			<Box style={{ width: "100%" }}>
				<Toolbar
					sx={{ borderBottom: "1px solid #cdcdcd", gap: "2%" }}
					variant="dense"
				>
					<Typography variant="h6">T Mobile Data</Typography>
				</Toolbar>

				<Box display={"flex"} justifyContent={"flex-end"} gap={2} padding={4}>
					<Button
						variant="contained"
						onClick={handleRefreshData}
						sx={{
							backgroundColor: "#fff",
							paddingY: 1,
							marginBottom: 0.5,
							"&:hover": { backgroundColor: "#fff" },
							minWidth: "50px",
						}}
					>
						<Refresh color="primary" />
					</Button>
					<Grid>
						<Controls.Select
							name="limit"
							options={Limits}
							value={limit || ""}
							label="Count"
							size="small"
							onChange={handleLimitChange}
							required
						/>
					</Grid>
				</Box>

				<Box paddingX={4}>
					{loading ? (
						<CircularProgress />
					) : deviceData?.length === 0 ? (
						<Typography>No Device Data</Typography>
					) : (
						<>
							{deviceData?.map((deviceObj: any, index: any) => (
								<>
									<Accordion key={`${index}`}>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls={`panel-content`}
											id={`panel-header`}
											sx={{ backgroundColor: "#faebd7" }}
										>
											<Typography>
											{new Date(deviceObj.timestamp.split(' ')[0] + 'T' + deviceObj.timestamp.split(' ')[1] + 'Z').toLocaleString('en-US', {
												year: 'numeric',
												month: '2-digit',
												day: '2-digit',
												hour: '2-digit',
												minute: '2-digit',
												second: '2-digit',
												hour12: false,
												timeZoneName: 'short'
												})}

											</Typography>
										</AccordionSummary>
										<AccordionDetails>
											<Typography>
												{JSON.stringify(deviceObj?.values)}
											</Typography>
										</AccordionDetails>
									</Accordion>
								</>
							))}
						</>
					)}
				</Box>
			</Box>
		</Box>
	);
}
